"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmojiToolbarDropdown = EmojiToolbarDropdown;
var _react = _interopRequireDefault(require("react"));
var Popover = _interopRequireWildcard(require("@radix-ui/react-popover"));
var _jsxRuntime = require("react/jsx-runtime");
function EmojiToolbarDropdown(_ref) {
  var children = _ref.children,
    control = _ref.control,
    isOpen = _ref.isOpen,
    setIsOpen = _ref.setIsOpen;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Popover.Root, {
    onOpenChange: setIsOpen,
    open: isOpen,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Popover.Trigger, {
      asChild: true,
      children: control
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Popover.Portal, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Popover.Content, {
        style: {
          zIndex: 10000000
        },
        className: "z-[10000] bg-white",
        children: children
      })
    })]
  });
}